(function ($) {
    'use strict';
    $(document).ready(function () {
        var selector = "select[multiple]:enabled:not(#sylius_product_attribute_choice)";

        transformSelects(selector);

        $("div[data-form-collection='list']").bind("DOMSubtreeModified", function () {
            transformSelects(selector);
        });

        function transformSelects(selector) {
            $(selector).each(function(i, selectToOrder) {
              var options = $(selectToOrder).find('option');

              var arr = options.map(function(_, o) {
                return {
                  t: $(o).text(),
                  v: o.value,
                  s: $(o).prop('selected'),
                };
              }).get();

              // console.log(arr);

              arr.sort(function(o1, o2) {
                return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
              });

              // console.log(arr);

              options.each(function(i, o) {
                  o.value = arr[i].v;
                  $(o).text(arr[i].t);
                  $(o).prop('selected', arr[i].s);
              });
            });

            $(selector).multiselect({
                columns: 1,
                selectAll: true,
                showCheckbox: true,
                search: true,
            });
        }
    });
})(jQuery);
